export default __webpack_public_path__ + "static/media/MaharajaVideo.44c8655e.mp4";